export enum GgnWeightingSchoolCareer {
    without = 0,
    regionalOrVocational = 1,
    gymnasium = 2
}